import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { ConfigService } from '../services/config.service';
import { InitService } from '../services/init.service';

export function initializeKeycloak(keycloak: KeycloakService, initService: InitService) {
  return () =>
    initService.getConfigAsync().then(config => {
      window['env'] = {
        ...environment,    // Compiled defaults (lowest priority)
        ...window['env'],  // Runtime env.js values (higher priority - overrides environment)
        ...config          // Server config (highest priority)
      };
      for (const key in config) {
        if (config.hasOwnProperty(key)) {
          window['env'][key] = config[key];
        }
      }
      console.log('Dynamic environment loaded:', window['env']);

      // For non-appliance mode (pip-installable), skip init check entirely
      const applianceMode = window['env']['applianceMode'];
      const skipAuth = window['env']['skipAuth'] || window['env']['localMode'] || !ConfigService.keycloakUrl;

      const initPromise = applianceMode === false
        ? Promise.resolve({ initialized: true })  // Pip-installable: always initialized
        : initService.getAsync();                  // Appliance: check server

      return initPromise.then((results: any) => {
        ConfigService.initialized = results.initialized;

        if (!ConfigService.initialized || skipAuth) {
          console.log('Skipping Keycloak initialization (skipAuth:', skipAuth, ', initialized:', ConfigService.initialized, ', applianceMode:', applianceMode, ')');
          return Promise.resolve(true);
        } else {
          let realm = ConfigService.keycloakRealm;
          if (ConfigService.saasMode) {
            realm =
              window.location.hostname === 'localhost' || window.location.hostname.split('.')[0] === 'demo'
                ? ConfigService.keycloakRealm
                : window.location.hostname.split('.')[0].toUpperCase();
          }

          var initOptions = {
            config: {
              url: ConfigService.keycloakUrl,
              realm: realm,
              clientId: ConfigService.keycloakClientId,
            },
            initOptions: {
              onLoad: 'check-sso',
              silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
              refreshToken: true,
              flow: 'standard',
              responseType: 'code',
              responseMode: 'query'
            },
            loadUserProfileAtStartUp: true,
            enableBearerInterceptor: true,
            bearerPrefix: 'Bearer'
          };

          console.log('Keycloak Init Options:', initOptions);

          return keycloak.init((<any>initOptions)).then(
            (authenticated) => {
              console.log('Keycloak Authenticated:', authenticated);
              return authenticated;
            },
            (error) => {
              console.error('Keycloak Init Error:', error);
              return false;
            }
          );
        }
      });
    }).catch(error => {
      console.error('Error loading configuration or initializing Keycloak:', error);
      ConfigService.apiError = true;
      return false; // API unreachable - will show error instead of redirect to /init
    });
}
